import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-community';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useCallback, useMemo } from 'react';
import { fetchAccountsV2Promise } from 'reducers/accountsReducer';
import { GetAccountsV2Response } from 'ts/api/accounts_v2';
import parseAGRequest from 'utils/agGrid/ssrm/parseAGRequest';
import { processSSRM } from 'utils/agGrid/ssrm/processSSRM';
import { CLEARING } from 'constants/accountTypes';
import BalanceGridRow from './types';

const useDatasource = () => {
  const dispatch = useAppDispatch();

  const fetchData = useCallback(
    async (params: IServerSideGetRowsParams) => {
      const { request } = params;
      const body = parseAGRequest(request, { transformAttrs: true });

      const result: GetAccountsV2Response = await fetchAccountsV2Promise(
        {
          ...body,
          filter: [
            { attr: 'account_type', op: 'eq', value: CLEARING },
            ...(body?.filter ? body.filter : []),
          ],
          showUsers: true,
        },
        dispatch,
      );
      return {
        rows: result?.accounts ?? [],
        count: result?.count ?? undefined,
      };
    },
    [dispatch],
  );

  const getRows = useCallback(
    (params: IServerSideGetRowsParams<BalanceGridRow>) =>
      processSSRM<BalanceGridRow>(params, fetchData),
    [fetchData],
  );

  const datasource: IServerSideDatasource = useMemo(
    () => ({
      getRows,
    }),
    [getRows],
  );
  return datasource;
};

export default useDatasource;
